"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeaderLink = void 0;
var React = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var core_1 = require("@material-ui/core");
var urls_1 = __importDefault(require("../../app/urls"));
var TrackedLink_1 = __importDefault(require("./TrackedLink"));
var constants_1 = require("../constants");
var icons_1 = require("../icons");
var theme_1 = require("../../app/style/theme");
var components_1 = require("../../youwell-common/components");
var Auth_1 = __importDefault(require("../../youwell-common/Auth"));
var appSetup_1 = require("../../app/appSetup");
var objectUtils_1 = require("../../youwell-common/objectUtils");
var constants_2 = require("../../youwell-common/constants");
var ElementIconOrDefault_1 = require("../icons/ElementIconOrDefault");
var taskUtils_1 = require("../taskUtils");
var store_1 = require("../../app/store");
var AuthStore = __importStar(require("../../app/store/AuthStore"));
var translate_1 = __importDefault(require("../../app/localization/translate"));
var headerLinksBreakWidth = 785;
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c, _d, _e;
    return ({
        root: (_a = {
                height: theme_1.headerHeight,
                padding: theme.spacing(1, 4),
                background: theme.palette.primary.main,
                color: theme.palette.common.white,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            },
            _a[theme.breakpoints.down('md')] = {
                justifyContent: 'space-between',
            },
            _a[theme.breakpoints.down('sm')] = {
                padding: theme.spacing(1, 3),
            },
            _a[theme.breakpoints.down('xs')] = {
                padding: theme.spacing(1, 2),
            },
            _a['& a, & button'] = {
                boxShadow: 'none',
                fontSize: '0.9em',
            },
            _a),
        leftTitle: {
            display: 'flex',
            alignItems: 'center',
            padding: theme.spacing(0, 1),
        },
        titleLogo: {
            maxHeight: theme_1.headerHeight - theme.spacing(2),
            maxWidth: 200,
        },
        titleText: {
            fontWeight: 500,
            fontSize: '1.25em',
        },
        pageTitle: {
            flex: '1 1 auto',
        },
        flex: {
            flex: '1 1 auto',
        },
        headerLinks: (_b = {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-end'
            },
            _b[theme.breakpoints.down('xs')] = {
                display: 'none',
            },
            _b),
        stayOnSmall: {},
        link: (_c = {
                display: 'flex',
                alignItems: 'center',
                padding: theme.spacing(0.5, 1.75)
            },
            _c[theme.breakpoints.down(headerLinksBreakWidth)] = {
                marginRight: theme.spacing(3),
            },
            _c[theme.breakpoints.down('xs')] = {
                display: 'none',
                '&$stayOnSmall': {
                    display: 'flex',
                    marginRight: 0,
                },
            },
            _c),
        linkContent: {
            display: 'flex',
            alignItems: 'center',
        },
        linkIcon: (_d = {
                marginRight: theme.spacing(0.5),
                fontSize: theme.typography.body2.fontSize
            },
            _d[theme.breakpoints.down(headerLinksBreakWidth)] = {
                marginRight: 0,
                fontSize: '1.5rem',
                '$stayOnSmall &': {
                    marginRight: theme.spacing(0.5),
                },
            },
            _d['$iconOnly &'] = {
                fontSize: 24,
            },
            _d),
        iconOnly: {},
        linkText: (_e = {
                fontWeight: 500,
                fontSize: '1em'
            },
            _e[theme.breakpoints.down(headerLinksBreakWidth)] = {
                display: 'none',
                '$stayOnSmall &': {
                    display: 'flex',
                },
            },
            _e),
        badge: {},
        menuButton: {
            marginLeft: theme.spacing(3),
            padding: 0,
            color: theme.palette.primary.contrastText,
        },
        menuIcon: {
            fontSize: '2rem',
        },
    });
});
var HeaderLink = function (_a) {
    var _b;
    var to = _a.to, text = _a.text, label = _a.label, classes = _a.classes, Icon = _a.Icon, unread = _a.unread, iconOnly = _a.iconOnly, stayOnSmall = _a.stayOnSmall;
    return (
    // @ts-ignore -- to and label is not correct props for Button (but forwarded to TrackedLink..)
    React.createElement(core_1.Button, { to: to, label: "".concat(constants_1.activityLabels.header, "/").concat(label), component: TrackedLink_1.default, color: "primary", variant: "contained", className: (0, classnames_1.default)(classes.link, (_b = {}, _b[classes.iconOnly] = iconOnly, _b[classes.stayOnSmall] = stayOnSmall, _b)) },
        React.createElement(core_1.Badge, { badgeContent: unread, className: classes.badge, color: "secondary", overlap: "rectangular" },
            React.createElement("div", { className: classes.linkContent },
                Icon && React.createElement(Icon, { className: classes.linkIcon }),
                !iconOnly && (React.createElement(core_1.Typography, { variant: "caption", color: "inherit", className: classes.linkText }, text))))));
};
exports.HeaderLink = HeaderLink;
exports.HeaderLink.defaultProps = {
    unread: 0,
    text: null,
    Icon: null,
    iconOnly: false,
    stayOnSmall: false,
};
var Header = function (_a) {
    var _b;
    var onOpenMenu = _a.onOpenMenu, hideLinks = _a.hideLinks, hideMenu = _a.hideMenu, pageTitle = _a.pageTitle, hideAppTitle = _a.hideAppTitle, defaultItems = _a.defaultItems, headerActions = _a.headerActions;
    var translate = (0, translate_1.default)();
    var classes = useStyles();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var profileData = (0, store_1.useYouwellSelector)(function (state) { return state.auth.profileData; });
    var clientConfig = (0, store_1.useYouwellSelector)(function (state) { return state.auth.clientConfig; });
    var unreadMessages = (0, store_1.useYouwellSelector)(function (state) { return state.user.unreadMessages; });
    var currentProgram = (0, store_1.useYouwellSelector)(function (state) { return state.programStore.currentProgram; });
    var appConfig = (0, store_1.useYouwellSelector)(function (state) { return state.pageSettings.appConfig; });
    var notifications = unreadMessages > 0 ? 1 : 0;
    var appItems = ((_b = currentProgram === null || currentProgram === void 0 ? void 0 : currentProgram.appElements) === null || _b === void 0 ? void 0 : _b.filter(function (d) { return (0, taskUtils_1.hasElementSetting)(d, constants_1.patientProgramAppElementSettings.header, true) && !d.disabled; })) || [];
    var hasCurrentProgram = (0, objectUtils_1.hasValue)(currentProgram);
    var hasActiveProgram = currentProgram === null || currentProgram === void 0 ? void 0 : currentProgram.isActiveProgram;
    var allowMenu = clientConfig.appSetup.features.menu && !hideMenu;
    var homeLink = hasCurrentProgram ? urls_1.default.inside.home : urls_1.default.home;
    var logoutOrg = function () {
        dispatch(AuthStore.actionCreators.logoutOrg());
    };
    var renderItem = function (item) {
        var _a, _b;
        switch (item) {
            case appSetup_1.headerItems.title:
                return !hideAppTitle && (
                // @ts-ignore -- to and label is not correct props for Button (but forwarded to TrackedLink..)
                React.createElement(core_1.Button, { key: appSetup_1.headerItems.title, color: "primary", variant: "contained", component: TrackedLink_1.default, to: homeLink, label: "".concat(constants_1.activityLabels.header, "/").concat(appSetup_1.headerItems.title), className: classes.leftTitle, title: translate('header.toMainPage') }, appConfig.titleLogo ? (React.createElement(components_1.Image, { src: appConfig.titleLogo.replace('.png', '-transp.png'), className: classes.titleLogo, alt: "Logo" })) : (React.createElement(core_1.Typography, { variant: "subtitle1", color: "inherit", className: classes.titleText }, translate('header.title')))));
            case appSetup_1.headerItems.pageTitle:
                return (React.createElement("div", { key: appSetup_1.headerItems.pageTitle, className: classes.pageTitle },
                    React.createElement(core_1.Typography, { align: "center", variant: "subtitle1", color: "textPrimary", className: classes.titleText }, pageTitle)));
            case appSetup_1.headerItems.flex:
                return (React.createElement("div", { key: appSetup_1.headerItems.flex, className: classes.flex }));
            case appSetup_1.headerItems.org:
                return (profileData === null || profileData === void 0 ? void 0 : profileData.connectedOrganizations) && ((_a = profileData === null || profileData === void 0 ? void 0 : profileData.connectedOrganizations) === null || _a === void 0 ? void 0 : _a.length) > 1 && (React.createElement(core_1.ButtonBase, { key: appSetup_1.headerItems.org, onClick: logoutOrg, className: classes.link },
                    React.createElement("div", { className: classes.linkContent },
                        React.createElement(icons_1.OrgIcon, { className: classes.linkIcon }),
                        React.createElement(core_1.Typography, { variant: "caption", color: "inherit", className: classes.linkText }, (_b = profileData.organization) === null || _b === void 0 ? void 0 : _b.name))));
            case appSetup_1.headerItems.menu:
                return allowMenu && (React.createElement(core_1.IconButton, { key: appSetup_1.headerItems.menu, color: "inherit", "aria-label": translate('openMenu'), onClick: onOpenMenu, className: classes.menuButton },
                    React.createElement(core_1.Badge, { badgeContent: notifications, color: "secondary", classes: { badge: classes.badge }, overlap: "rectangular" },
                        React.createElement(icons_1.MenuIcon, { className: classes.menuIcon }))));
            case appSetup_1.headerItems.chat:
                return hasActiveProgram && !hideLinks && clientConfig.appSetup.features.chat && (React.createElement(exports.HeaderLink, { key: appSetup_1.headerItems.chat, label: appSetup_1.headerItems.chat, to: urls_1.default.inside.chat, text: translate('header.messages'), classes: classes, Icon: icons_1.ChatIcon, unread: unreadMessages }));
            case appSetup_1.headerItems.favourites:
                return hasCurrentProgram && !hideLinks && clientConfig.appSetup.features.favourites && (React.createElement(exports.HeaderLink, { key: appSetup_1.headerItems.favourites, label: appSetup_1.headerItems.favourites, to: urls_1.default.inside.pages.favourites, text: translate('header.favourites'), classes: classes, Icon: icons_1.FavouritesIcon }));
            case appSetup_1.headerItems.profile:
                return !hideLinks && clientConfig.appSetup.features.profile && (React.createElement(exports.HeaderLink, { key: appSetup_1.headerItems.profile, label: appSetup_1.headerItems.profile, to: urls_1.default.inside.profile, text: translate('header.myProfile'), classes: classes, Icon: icons_1.PersonIcon }));
            case appSetup_1.headerItems.logout:
                return Auth_1.default.getLoginLevel() > constants_2.loginLevels.key && (React.createElement(exports.HeaderLink, { key: appSetup_1.headerItems.logout, label: appSetup_1.headerItems.logout, to: urls_1.default.logout, text: translate('logout'), classes: classes, Icon: icons_1.LogoutIcon, stayOnSmall: !allowMenu }));
            case appSetup_1.headerItems.login:
                return Auth_1.default.getLoginLevel() < 1 && (React.createElement(exports.HeaderLink, { key: appSetup_1.headerItems.login, label: appSetup_1.headerItems.login, to: urls_1.default.login, text: translate('login.login'), classes: classes, stayOnSmall: !allowMenu }));
            case appSetup_1.headerItems.appItems: {
                return !hideLinks && appItems.map(function (el) { return (React.createElement(exports.HeaderLink, { key: el.id, to: "".concat(urls_1.default.inside.program, "/").concat(el.elementGroup, "/").concat(el.indexInGroup), text: el.name, classes: classes, label: "app/".concat(el.name), Icon: (0, ElementIconOrDefault_1.getElementIcon)(el) })); });
            }
            case appSetup_1.headerItems.pages: {
                return !hideLinks && hasActiveProgram && clientConfig.appSetup.pages.filter(function (d) { return hasCurrentProgram || !d.hideIfNoProgram; }).map(function (el) { return (React.createElement(exports.HeaderLink, { key: el.key, to: el.url, text: translate(el.nameKey), classes: classes, label: "page/".concat(el.key), Icon: el.Icon })); });
            }
            case appSetup_1.headerItems.customActions: {
                return headerActions === null || headerActions === void 0 ? void 0 : headerActions.map(function (action) { return (React.createElement(core_1.Button, { key: action.text, onClick: action.action, color: "primary", variant: "contained", className: (0, classnames_1.default)(classes.link, classes.stayOnSmall) },
                    React.createElement("div", { className: classes.linkContent },
                        React.createElement(core_1.Typography, { variant: "caption", color: "inherit", className: classes.linkText }, action.text)))); });
            }
            default:
                return null;
        }
    };
    var hasMenuInHeader = clientConfig.appSetup.header.findIndex(function (d) { return d === appSetup_1.headerItems.menu; }) > -1;
    var hasLogoutInHeader = clientConfig.appSetup.header.findIndex(function (d) { return d === appSetup_1.headerItems.logout; }) > -1;
    return (React.createElement("div", { className: classes.root }, !hasCurrentProgram ? defaultItems === null || defaultItems === void 0 ? void 0 : defaultItems.map(renderItem) : (React.createElement(React.Fragment, null,
        clientConfig.appSetup.header.map(renderItem),
        allowMenu && !hasMenuInHeader && (React.createElement(core_1.Hidden, { implementation: "css", smUp: true }, renderItem(appSetup_1.headerItems.menu))),
        !allowMenu && !hasLogoutInHeader
            && renderItem(appSetup_1.headerItems.logout)))));
};
Header.defaultProps = {
    hideLinks: false,
    hideMenu: false,
    hideAppTitle: false,
    pageTitle: null,
    onOpenMenu: null,
    defaultItems: [appSetup_1.headerItems.title, appSetup_1.headerItems.flex, appSetup_1.headerItems.org, appSetup_1.headerItems.logout],
    headerActions: null,
};
exports.default = Header;
